import { gettext } from '@eventbrite/i18n';

export const FORM_HEADLINE = gettext('Calculate your potential earnings');

export const TICKET_PRICE_LABEL = gettext('Ticket Price');
export const TICKET_QUANTITY_LABEL = gettext('Tickets Sold');
export const PASS_ON_FEES_LABEL = gettext('Fee Handling');

export const PASS_ON_FEES_OPTION = gettext('Pass fees on to attendees');

export const ABSORB_FEES_OPTION = gettext('Absorb fees');

export const RESULTS_HEADLINE = gettext('Your estimated payout');

export const ATTENDEE_PAYS = gettext('Attendee pays');

export const RESULTS_CTA = gettext('Create event');

export const CHANGE_PLAN_CTA = gettext('Change your plan');

export const PASS_ON_FEES_SECONDARY_TEXT = gettext(
    'Attendees pay ticketing fees',
);
export const ABSORB_FEES_SECONDARY_TEXT = gettext(
    'Ticketing fees  are deducted from your payout',
);

export const FEE_HANDLING_TOOLTIP_TEXT = gettext(
    'The majority of organizers who pass fees to their buyers pay nothing out of pocket to use Eventbrite. Visit FAQs below to learn more about passing on fees.',
);

export const ESTIMATE_TOOLTIP_TEXT = gettext(
    "Estimates provided for informational purposes only. Actual totals may vary. Estimates do not include all applicable taxes. Visit FAQs below to learn more about Eventbrite's pricing options.",
);

export const PACKAGE_SELECT_LABEL = gettext('Choose a package');
export const ESSENTIALS_LABEL = gettext('Essentials Package');
export const ESSENTIALS_DETAILS = gettext(
    'Fees based on our Essentials package and include Eventbrite Payment Processing.',
);
export const PROFESSIONAL_LABEL = gettext('Professional Package');
export const PROFESSIONAL_DETAILS = gettext(
    'Fees based on our Professional package and include Eventbrite Payment Processing.',
);

export const IMPOSSIBLE_PRICE_TITLE = gettext('Oops!');

export const IMPOSSIBLE_PRICE_TEXT = gettext(
    "You can't absorb fees greater than your ticket cost. Please try again.",
);
